import styled from 'styled-components';

import { media } from 'helpers/breakpoints';

import type { ThemeTypes } from 'types/Theme.namespace';

interface ValueProps {
  valueSmallFontSize: ThemeTypes.FontSize;
}

interface LabelProps {
  isGrid?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: end;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const PriceLabelWrapper = styled.div<{ flip?: boolean }>`
  position: relative;
  ${({ theme }) => theme.fontSize.M14};

  ${media.medium} {
    order: ${({ flip }) => (flip ? '2' : '0')};
  }
`;

const PriceDrop = styled.span`
  ${({ theme }) => theme.fontSize.B10};
  color: ${({ theme }) => theme.colors.RED};
  position: relative;

  ${media.medium} {
    ${({ theme }) => theme.fontSize.M14};
  }

  &:after {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: inherit;
    transform: rotate(-12.2deg);
  }
`;

const Label = styled.p<LabelProps>`
  display: ${({ isGrid }) => (isGrid ? 'none' : 'inline-block')};
  ${({ theme }) => theme.fontSize.M14};

  ${media.medium} {
    display: inline-block;
  }
`;

const Text = styled.p<ValueProps>`
  ${({ theme, valueSmallFontSize }) => theme.fontSize[valueSmallFontSize]};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.GREY_DARKER};

  ${media.medium} {
    ${({ theme }) => theme.fontSize.L18};
  }
`;

const NextToPriceContainer = styled.div`
  border-left: solid ${({ theme }) => theme.colors.GREY_LIGHT} 1px;
  padding-left: ${({ theme }) => theme.spacing.S8};
  margin-left: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    padding-left: ${({ theme }) => theme.spacing.M16};
    margin-left: ${({ theme }) => theme.spacing.M16};
  }
`;

const PPMDisplay = styled.span`
  ${({ theme }) => theme.fontSize.B12};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export {
  Container,
  NextToPriceContainer,
  PriceLabelWrapper,
  PriceDrop,
  Label,
  Text,
  PPMDisplay,
  PriceContainer,
};
